module.exports = __webpack_public_path__ + "img/img18.8d9cc0fb.svg";